import script from "./OrderConfirmed.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderConfirmed.vue?vue&type=script&setup=true&lang=js"

import "./OrderConfirmed.vue?vue&type=style&index=0&id=a4b6585a&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4b6585a"]])

export default __exports__